import { ReactNode } from 'react'

import { IDate } from '@avantstay/arriere-clients/dist/arriereBackoffice'

import { OmniSearchStore } from '@new/__global/components/OmniSearch/OmniSearchStore'

export interface SharedResultsProps {
  totalCount: number
  searchTerm: string
}

export enum SearchPrefix {
  PROPERTIES = 'p:',
  BOOKINGS = 'b:',
  USERS = 'u:',
  HOMEOWNERS = 'h:',
  ANY = 'any',
}

export enum ResultTabEnum {
  ALL,
  PROPERTIES,
  BOOKINGS,
  USERS,
  HOMEOWNERS,
}

export interface WithNavigationProps {
  activeIndex: number
  setIndex: (index: number) => void
  enabledNavigation?: boolean
}

export interface IResultsTemplateProps<T> extends WithNavigationProps, SharedResultsProps {
  data: T[]
  renderChildren: (it: T) => ReactNode
  titlePrefix: string
  baseUrl: string
  queryParamKey: string
  onClick: (it: T) => void
}

export interface ItemProps {
  isFocused?: boolean
}

export interface IBookingsResultsProps extends WithNavigationProps, SharedResultsProps {
  total?: number
  bookings: Array<OmniSearchBooking>
  homes?: Array<OmniSearchHome>
  linkTarget?: string
  onClick?: (booking: OmniSearchBooking) => void
}

export interface IPropertiesResultsProps extends WithNavigationProps, SharedResultsProps {
  total?: number
  homes: Array<OmniSearchHome>
}

interface CheckInOutTiming {
  effectiveTime: IDate
}

export interface BookingBasicResult {
  hash: string
  checkInTiming: CheckInOutTiming
  checkOutTiming: CheckInOutTiming
  home: {
    id?: string
    name: string
    region?: {
      id: string
      name: string
    }
  }
}

export interface IUserResultsProps extends WithNavigationProps, SharedResultsProps {
  homes: Array<OmniSearchHome>
  total?: number
  users: Array<OmniSearchUser>
}

export type OmniSearchUser = (typeof OmniSearchStore.guestsSearchResults)['results'][0]
export type OmniSearchBooking = (typeof OmniSearchStore.bookingsSearchResults)['results'][0]
export type OmniSearchHome = (typeof OmniSearchStore.homesSearchResults)['results'][0]
export type OmniSearchHomeowner = (typeof OmniSearchStore.homeownersSearchResults)['results'][0]
